<template>
  <div>
    <pre>
■サービス利用規約

第１条（本規約の目的）
本規約は、パナソニック株式会社（以下「当社」といいます）がスムースエピアプリ iOS版/Android版（以下、「本アプリ」といいます）上で提供するサービス（以下「本サービス」といいます）を、ご利用いただく方（以下総称して「利用者」といいます）に適用される利用条件を規定するものです。

第２条（諸規定等）
本サービスに関して本規約とは別に定める利用条件、利用方法、ご利用上の注意、プライバシーポリシーその他本サービスに関する規定のうち、利用者が本サービスの全部または一部を利用する前に、当社がその内容について利用者の承諾を取得する規定（以下「諸規定等」といい、CLUB Panasonic会員利用規約を除きます）は、本規約の一部を構成するものとします（以下、本規約と「諸規定等」を合わせて「本規約等」といいます）。なお、本規約の定めと諸規定等の定めが矛盾抵触する場合は、諸規定等の定めが優先して適用されるものとします。また、本サービスに関して、諸規定等に定めのない事項は本規約によるものとします。

第３条（サービスの開始）
１．本サービスの利用希望者（以下「利用希望者」といいます）は、本規約の内容を承諾し、これを順守することを条件として本サービスを利用することができます。ただし、諸規定等の内容を承諾しない場合、本サービスの一部が利用できないことがあります。なお、利用希望者が本規約等に『同意する』を選択された時点をもって、本規約等の内容は、利用希望者により本サービスに関する契約の内容として承諾されたものとみなします。
２．利用希望者は、本サービスの画面上における所定の手続きに従って、本サービスを利用することができるものとします。また利用希望者は、画面上の指示に従い本サービスの対象となる美容家電に関連する情報を登録するものとします。
３．本サービスにおいてスマートフォンへのプッシュ通知サービスの利用希望者は、ご利用になるスマートフォンのOS（Operating System）で通知設定を有効にした上で、本サービスの各機能別に、通知設定を有効にするものとします。

第４条（会員登録手続）
１．利用希望者は、本規約等に同意のうえ、本サービスの利用を開始するものとします。なお、本アプリを利用するにあたっては、当社所定の手続に従い、本アプリの登録手続を行っていただくものとします。
２．当社は、CLUB Panasonic会員登録の有無により、本サービスを利用することの可否、本サービスにおける内容および各機能の提供の有無を異なるものとすることができるものとします。これらの事項は、当社が任意に決定し、また随時、本規約第７条に定める手続により追加および変更することができるものとします。CLUB Panasonic会員が本サービスを利用する場合には、本規約等に定めのない事項は、CLUB Panasonic会員利用規約の定めによるものとします。なお、本規約等の定めとCLUB Panasonic会員利用規約の定めが矛盾抵触する場合は、本規約等の定めが優先して適用されるものとします。
３．利用希望者が本サービスの利用開始とあわせてCLUB Panasonic会員となる場合には、CLUB Panasonicの会員利用規約に同意のうえ、当社所定の手続に従い、CLUB Panasonicの登録手続を行っていただくものとします。
４．本規約等は、日本国内にお住まいの利用希望者および利用者を対象とします。未成年の方が本サービスを利用される場合は、親権者の承諾を得てご利用いただくものとします。

第５条（費用負担）
１．別途当社の定める場合を除き、本サービスは無料で利用可能です。ただし、当社が、有料の本サービスを提供する場合、別途当社の定める有料サービス用の利用規約が適用され、利用者は当該利用規約に同意の上、順守するものとします。
２．前項にかかわらず、本サービスを利用するために必要な美容家電、スマートフォン、無線LANルーター、無線ゲートウェイ、無線アダプター等の通信機器に関する費用、スマートフォンやパーソナルコンピュータ等の機器・端末に関する費用、およびネットワークサービス提供者との接続その他通信等に関する費用は、利用者が自らの責任と負担のもとで管理するものとします。 

第６条（本サービスの一時中断）
当社は、以下のいずれかの事由が生じた場合には、利用者に事前に通知することなく、一時的に本サービスを中断することができるものとします。
（１）本サービスの提供に関連する設備等の保守を定期的にまたは緊急に行う場合
（２）火災、停電または天災地変その他不可抗力により本サービスの提供ができなくなった場合
（３）ネットワークサービス提供者によるサービス、本サービスの全部または一部を構成するコンテンツを提供する当社以外の事業者によるサービスその他本サービスの全部または一部を利用するために必要なサービスであって、当社以外の第三者が提供するもの（以下「第三者サービス」といいます）が何らかの事情により中断した場合
（４）その他、管理・運営上または技術上の理由で、当社が、本サービスの一時的な中断が必要と判断した場合 

第７条（本サービスの変更・追加等、終了・中止）
１．当社は、本サービスおよびその内容の変更、追加等、ならびに本サービスの利用に必要となる環境等の条件の変更、追加等（本サービスの保守上、工事上、その他の事情により行うものを含む）を、本サービスの全てまたは一部を有料へ変更する場合を除き、利用者への事前の通知なく行うことができるものとします。ただし、その変更、追加等が本規約等の変更を伴う場合は、第８条に従うものとします。 
２．当社は、事前に相応なる期間をもって、第９条に基づき利用者に通知することにより、本サービスの全部または一部を終了または中止することができるものとします。なお、この場合、当該サービスを再開させるか、または代替サービスを提供するかどうかは、当社が判断することとします。
３．当社は、事前に相応なる期間をもって、第９条に基づき利用者に通知することにより、本規約等に基づく権利および義務の全部または一部を第三者に譲渡し、または承継させることができるものとします。この場合、第８条の定めが準用されることとします。
４．本条第２項の定めにかかわらず、第三者サービスが十分な周知期間を置かずに終了する場合等、事前に相応なる期間の通知を行うことが事実上、不可能であると相当な理由をもって判断される場合には、当社は、事前の通知なく、本サービスの全部または一部を終了または中止することができるものとします。

第８条（本規約等の変更）
１．当社は、利用者の一般の利益に適合する限り、または、契約の目的に反せず、かつ合理的な変更である限り、あらかじめ利用者の承諾を得ることなく、第９条に基づき、本規約等を変更する旨および変更後の本規約等の内容、ならびに当該変更等の効力発生時期を、当社が定める発効日よりも前に通知することにより、本規約等を変更することができるものとします。この場合、当社は、事前に相応なる期間をもって、当該通知を行います。利用者は変更された本規約等を順守するものとします。なお、変更の内容は、当社が定める発効日より効力を有するものとします。
２．前項にかかわらず、法令等により、本規約等の変更につき、利用者の承諾が必要な場合、当社は利用者の承諾を得るものとします。なお、利用者は、変更内容について承諾をしないこともできますが、その場合、本サービスの全部または一部を利用できなくなることがあります。 

第９条（利用者への通知方法）
当社は、利用者への本サービスの提供に関して、当社が利用者へのなんらかの通知が必要であると判断した場合には、本サービス画面上への掲示、スマートフォンへのプッシュ通知、CLUB Panasonicに登録されているメールアドレス（以下「本件登録アドレス」といいます）宛に電子メールを送信する方法、SMSで通知する方法、またはCLUB Panasonicアプリ上での通知のいずれかによって通知をするものとします。

第１０条（利用者の責任）
１．利用者は、本サービスを利用した美容家電の操作・設定（美容家電を中古品として譲り受けた場合に、当該美容家電の取扱説明書の記載にしたがって、当該美容家電の設定を初期化することを含みます）、データの収集・利用、コンテンツの作成・利用（本アプリ内のコンテンツを参考にして美容家電を使用することを含みます）その他の本サービスの利用について、利用者自らの責任で行なうものとします。
２．利用者は、本サービスを正常に利用するために必要な美容家電、通信機器、通信回線、スマートフォンやパーソナルコンピュータ等の端末機器の設置、設定、維持・管理（端末機器のOSやセキュリティパッチ等のソフトウェアを最新にアップデートすることを含む）について、利用者自らの責任で行なうものとします。
３ ．利用者 は、同居の家族等、利用者以外の第三者が本サービスを利用する場合、利用者は当該第三者に本規約等の内容を知らしめ、これを遵守させることとし、当該第三者が本規約等に違反することによって生じた損害については、利用者がその責任を負うこととします。
４．CLUB Panasonic会員である利用者は、本件登録アドレスに変更がある場合は、Panasonicウェブサイトの画面上における所定の変更手続きに従って、自らの責任において変更するものとします。
５．CLUB Panasonic会員である利用者は、本サービスを利用する際の本件登録アドレス等のID（以下、「本件ID」といいます）およびパスワードを自らの責任において管理するものとします。
６．利用者は、本規約等の定めた利用方法や手続き等に従わない場合、当社が本アプリの画面上で提示する指示にしたがわない場合、その他自己の責めに帰すべき事由によって、本サービスの全部または一部を利用できないことにつき、一切の責任を負うものとします。
７．利用者は、本サービスの利用に伴って他の利用者あるいは第三者から問合せ、申立等を受け、または紛議が生じた場合は、自己の責任と費用をもってそれを処理解決するものとします。ただし、それらの問合せや申立等が、当社の責めに帰すべき事由により生じた場合は、当社が当該問合せや申立等を処理解決するか、または利用者が当該問合せや申立等の処理解決に要した費用等の損害を第１７条第４項に定める範囲で賠償します。
８．利用者は、本サービスの利用において本規約等に違反することにより、当社、他の利用者または第三者に対して損害を与えた場合、自己の責任と費用をもって当該損害を被った者に対して、賠償責任を負うものとします。
９．利用者は、本サービスの画面上に掲示されるリンクから本サービス外のウェブサイト（以下「外部サイト」といいます）にアクセスした場合、自己の責任と費用をもって外部サイトを閲覧および外部サイトの提供するサービス（以下「外部サービス」といいます）を利用するものとします。 
１０．利用者は、本アプリを公式アプリストア（App Store / Google Play）からのみ入手するものとします。公式ストア以外から取得したアプリ（改ざん版を含む）についての安全性、動作、またそれにより生じた損害について、当社は一切の責任を負いません。

第１１条（登録コンテンツデータ）
１．本サービスで当社が提供する情報に係る著作権、商標権その他の知的財産権は当社または当社が本サービスにおける利用許諾を受けた他の権利保有者に帰属します。
２．利用者は、本サービスにおいて、利用者が登録、記載または投稿等した著作物およびデータ等（以下総称して「登録コンテンツデータ」といいます）を、当社（当社の子会社、関連会社等を含む。以下本条において同じ）が、当社事業のために、利用者に対価を支払うことなく、非独占的に、期間の限定なく使用・利用できること（当社が第三者に対する再使用許諾の権利を含みます）に、あらかじめ同意するものとします。
３．利用者は、登録コンテンツデータについて、著作権法上の権利を有していること、もしくは、第三者が著作権を有する著作物等を利用する場合には、前項における利用者の当社に対する許諾に必要な権利処理がされていることを保証するものとします。また利用者は、前項に定める当社または当社より使用許諾を受けた第三者による登録コンテンツデータの利用に関し、著作権法上の著作者人格権を行使せず、もしくは、権利者をして行使させないものとします。
４．利用者は、第三者が著作権を有する登録コンテンツデータを本サービスにおいて、前項に記載の場合を除き、登録、記載または投稿等してはならないものとし、第三者の著作権に関し、当社に如何なる迷惑・損害等もかけてはならないものとします。万一、利用者による第三者の著作権侵害により、当社が損害等を被った場合は、これを賠償するものとします。また、登録コンテンツデータについて、第三者から著作権等の権利侵害を理由として、当社に削除要請のあった場合、当社の判断により、事前の通知なく削除される場合のあることを承諾するものとします。
５．前項の場合のみならず、景品表示法等の観点から、登録コンテンツデータの公開が適切でないと当社が合理的に判断した場合には、当社は、事前の通知なく登録コンテンツデータの内容の変更または削除を行う場合があります。
６．利用者が、本サービス上の一部の機能を利用し、登録コンテンツデータを、情報投稿ウェブサイトまたはアプリ（例：Facebook、Ｘ（旧：Twitter））を通じて、ウェブに投稿する場合、利用者は、自己の判断と責任において実施するものとし、また当該投稿については各々の情報投稿ウェブサイトまたはアプリが定める規定が適用されることを認識し同意するものとします。また、利用者は、自己がウェブに投稿した登録コンテンツデータは、他の本サービス利用者等の第三者により端末へ保存する等の方法で利用され得ること、および当該ご利用者等により複数回投稿され得ること等を認識し同意するものとします。なお、登録コンテンツデータの投稿（第三者によるものを含む）に起因して発生しうるすべての問題につき、当社の責めに帰すべき事由によって発生した損害を除いて、当社は如何なる責任も負わないものとします。 

第１２条（オープンソースコンポーネント）
本サービスに関するプログラム（本アプリに関するプログラムのほか、本サービスに関する美容家電に内蔵のプログラムを含み、以下「本プログラム」といいます）には、ソースコードの形式で公開されており、その使用にあたって、対象となるコンポーネントおよびこれを基に開発されたソフトウェアを、ソースコードやオブジェクトコードの形式で開示または頒布する義務や、任意の第三者に自由に使用許諾させる義務等の条件を遵守することを前提に、自由に使用できるコンポーネント（GNU General Public License (GPL)やGNU Lesser/Library General Public License (LGPL)に基づいてライセンスされているコンポーネントを含むがこれに限られない）（以下「オープンソースコンポーネント」といいます）が含まれます。オープンソースコンポーネントの名称およびライセンス条件は、本アプリ内にてアプリケーション情報に記載の通りです。

第１３条（禁止事項）
利用者は、本サービスの利用において以下の行為を行わないものとします。
（１）他人の知的財産権（著作権、意匠権、商標権等）その他の権利を侵害する行為または侵害するおそれのある行為
（２）他人の財産、プライバシーもしくは肖像権を侵害する行為または侵害するおそれのある行為
（３）他人を誹謗中傷し、またはその名誉もしくは信用を毀損する行為
（４）（詐欺、業務妨害等の）犯罪行為またはこれを誘発もしくは扇動する行為
（５）わいせつ、児童ポルノもしくは児童虐待にあたる映像もしくは文書を送信し、または掲載する行為
（６）その他法令もしくは公序良俗に違反し、または他人の権利を著しく侵害すると当社が判断する行為
（７）当社の本サービスの円滑な運営を妨げる行為
（８）本サービスを営利目的として利用する行為
（９）本サービスにおける他の利用者の使用履歴等のデータを本人の事前の許諾なく不正に収集・使用・利用等する行為
（１０）本プログラム等の譲渡、貸与、頒布その他の処分行為、複製、公衆送信、リバースエンジニアリング等の解析行為および改造、改変行為、二次的著作物の創作、これらのプログラムの派生物を利用する行為、その他本規約等で定められた用法および利用者が本サービスを利用するために必要な範囲以外の一切の使用行為
（１１）反社会的勢力として活動すること、反社会的勢力に対する利益供与その他反社会的勢力と社会的に非難される関係を有すること、または法的な責任を超えて不当な要求行為を行うこと
（１２）コンピュータウイルス等の有害なプログラムを本サービスもしくは第三者に送信し、または流布する行為
（１３）本サービスが通常意図しないバグを利用する動作を生じさせ、または、通常意図しない効果を及ぼす外部ツールの利用、作成、または頒布を行う行為
（１４）本サービスのサーバーに過度の負担をかける行為
（１５）本サービスの他の利用者のIDまたはパスワードを、当該利用者の同意を得ることなく利用する行為
（１６）他の利用者や他人に対して迷惑となり、または不快感を抱かせる行為
（１７）前各号の行為を直接もしくは間接に惹起し、または容易にする行為
（１８）前各号に類似し、または準ずるような不適切な行為
（１９）前各号の行為を試みる行為
（２０）その他本サービスの運営上当社が不適切と判断する行為 

第１４条（権利譲渡の禁止）
利用者は、本サービスのご利用者としての資格、本サービスを利用する権利その他本規約等に基づく権利、義務の全部または一部を第三者に譲渡し、あるいは貸与、売買、名義変更、質権の設定その他の担保に供する等の行為を行うことはできないものとします。 

第１５条（本サービスの提供の停止または当社によるご利用資格の取消し）
当社は、利用者が次のいずれかに該当する場合、直ちに登録コンテンツデータの削除、本サービスの提供の停止または本サービスのご利用者としての資格の取消しの措置をとることができるものとします。なお、当社はその理由の開示を行いません。
（１）本規約第１３条に定める禁止事項のいずれかを行ったと当社が判断するとき
（２）本規約等に違反したとき
（３）お客様による必要登録事項の申告に、虚偽の記載、不備があったとき
（４）過去に、本規約等の違反等により本サービスの全部もしくは一部の利用を停止され、または本サービスのご利用者資格を抹消されたことがあったと当社が認識したとき
（５）利用希望者が実在しないとき
（６）その他利用者による本サービスの利用状況が適当でないと当社が判断したとき 

第１６条（利用契約の解除）
利用者は、以下の行為により本サービスの利用を中止することができるものとします。その行為の時点で利用者と当社との間の本サービスの利用に関する契約は解除され、さらに、利用者の個人情報、登録コンテンツデータ等が削除される場合があることに同意するものとします。
（１）利用者が本サービスの画面上の所定の手続きに従って、本サービスの利用停止（ユーザー削除）を選択すること

第１７条（免責事項）
１．当社は、本サービスの遅滞、終了、一時中断、ならびに本サービスおよびその内容の変更、追加等により、利用者が被った損害、損失、不利益等（以下「損害等」といいます）につき、損害等の発生について当社の責めに帰すべき事由がある場合を除き、一切責任を負わないものとします。
２．当社は、第１０条に関連して利用者の責任においてなされた行為から生じた損害や、利用者の責任においてなすべき行為をしなかったことによる損害や不利益等については、一切責任を負わないものとします。
３．当社は、当社の責めに帰すべき事由により生じた場合を除き、利用者による本サービスおよび本プログラムの利用、自らのアプリの誤操作、美容家電やアプリに関する情報を第三者が漏えいさせた場合、その他本サービスに起因する何らかの事由によって生じた損害等について、一切責任を負わないものとします。
４．前各項の定めにかかわらず、当社は、当社の責めに帰すべき事由により直接かつ通常の範囲内で利用者に生じた損害等につき、利用者に対し損害賠償責任を負うものとします。ただし、当該損害等が、当社の故意または重大な過失によって生じた場合は、当社は利用者に対し、民法および関係諸法令の定めるところにより、損害賠償責任を負うものとします。
５．本サービスを介して提供される第三者のコンテンツ配信サービス等の第三者サービスは、当該第三者サービスの提供者により、ソフトウェアを通じて提供されています。第三者サービスの対象であるコンテンツや第三者が提供するソフトウェアの選定、提供（利用可能性を含む）、品質（コンテンツの画像のサイズ含む）その他第三者サービスに関する一切の事項は、全て第三者サービスの提供者の責任において決定されています。第三者サービスの利用について、当該第三者サービスの提供者が定める条件がある場合、利用者はその条件に従って当該第三者サービスを利用するものとし、当社は、当社の責に帰すべき事由により生じた場合を除き、利用者が当該第三者サービスを利用したことその他何らかの事由により第三者サービスに起因して生じた損害等について、一切責任を負わないものとします。
６．本サービスの画面上に掲示される外部サイトへのリンクについて、当社は外部サイトの内容および外部サービスを利用した結果について一切責任を負わないものとします。 

第１８条（非保証）
当社は、本サービスの内容、本プログラム、本サービスを通じて提供される美容家電の操作・設定、美容家電の使用状況の提供等の一切の情報および本サービスの実行結果（本サービスを介して提供される第三者サービスの内容、これを通じて提供される一切の情報および第三者サービスの実行結果を含む）について、期待する機能、商品的価値、正確性、完全性、確実性、有用性、最新性等を有すること、利用者による本サービスの利用が利用者に適用のある法令または業界団体の内部規制等に適合すること、第三者の権利を侵害していないこと、継続的に利用できること、および不具合が生じないことについて、明示または黙示を問わず一切保証しないものとし、利用者は、自己の責任において利用するものとします。 

第１９条（分離可能性）
本規約等のいずれかの条項またはその一部が、消費者契約法その他の法令や裁判所の判決等により無効または執行不能と判断された場合であっても、無効または執行不能とされた部分以外のすべての定めは、継続して完全に効力を有するものとします。

第２０条（準拠法）
本規約等の成立、効力、履行および解釈等、本規約等に関する一切の事項については、日本法が適用されるものとします。 

第２１条（合意管轄）
利用者および当社は、本規約に基づく利用者と当社との本サービスの利用に関する契約について、訴訟の必要が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とすることに合意します。 

パナソニック株式会社
発効日2026年2月1日 



■Panasonic Beauty Point利用規約

パナソニック株式会社（以下、「当社」といいます）は、当社の発行するPanasonic Beauty Point（以下「本ポイント」といいます）の利用規約（以下、「本規約」といいます）を以下のとおり定めます。ポイント利用者は、本規約にご承諾いただいた上で、本ポイントをご利用いただくものとします。
第１条（定義）
本規約における用語を、以下のとおり定義します。
（１）「ポイント利用者」とは、当社が提供するアプリ『with Panasonic Beauty iOS 版』及び『スムースエピアプリ iOS版』（以下あわせて「本アプリ」といいます。なお、本ポイントをご利用いただける対象アプリは、当社の判断により変更することがあります）の利用者のうち、本アプリにCLUB Panasonic会員としてログインし、本サービスの利用を開始した方をいいます。
（２）「本サービス」とは、本アプリ（本アプリに関連するウェブページを含みます）上で利用できるポイントサービスのことをいいます。
（３）「ポイント交換パートナー企業」とは、当社との間で加盟契約し、ポイント利用者に対して、ポイントと引き換えに商品・サービスを提供することを承諾した企業をいいます。
（４）「CLUB Panasonicコイン」とは、当社及びパナソニックコンシューマーマーケティング株式会社が発行するポイントのことをいいます。

第２条（CLUB Panasonic会員利用規約との関係）
本規約に定めのない事項は、CLUB Panasonic会員利用規約に定めるところに拠るものとします。また、本規約とCLUB Panasonic会員利用規約において異なる定めがある事項については、本規約の定めが優先されるものとします。

第３条（ご利用方法）
１．本サービスのご利用には、本規約及び当社が定める各諸規定に同意いただき、利用登録の手続後、本アプリにアクセスし、CLUB Panasonic会員ID・パスワードで個人認証を受けていただく必要があります。
２．ポイント利用者による本サービスの利用につき、当社から書面による利用明細等の通知は一切行いません。なお、本ポイントとの交換によるCLUB Panasonicコインの付与状況に関しては、CLUB Panasonicコインサイト上において所定の方法でご参照ください。
３．本サービスのうち一部のサービスについて、利用登録手続完了後も一定期間が経過するまで、利用できない場合がありますのでご了承ください。また、18歳未満のポイント利用者は、本サービスのうち一部のサービスが利用できません。

第４条（本ポイントの付与）
本ポイントは、ポイント利用者が、本アプリ上で所定のサービスを利用し、又は所定の条件を達成した場合等に付与されます。本ポイント付与の対象となるサービス・条件等、本ポイント付与の要件及び付与される本ポイント数等については、当社が別途決定し、本アプリ上に表示します。

第５条（本サービスの自主的な終了）
ポイント利用者は、CLUB Panasonic会員を退会することにより、本サービスの利用を終了することができます。CLUB Panasonic会員の退会に際しては、当社所定の方法による手続（以下、「終了申請手続」といいます）を取るものとします。なお、終了申請手続時に残存している本ポイントは、終了申請手続の完了と同時に消滅するものとします。

第６条（利用資格の停止・取り消し等）
１.当社は、ポイント利用者が以下のいずれかの事項に該当すると判断した場合、何らの事前の通知・催告を行うことなく本サービスの利用資格を停止ないし取り消すことができます。
(１）本規約又は別途定めた各種規定に違反した場合
(２) 破産、民事再生手続等の申立をなし、もしくは申立を受ける等、その信用状態が著しく悪化した場合
(３) 12ヶ月以上にわたってポイントの交換、取得、又は利用を行わなかった場合
(４) CLUB Panasonic会員ID・パスワードを不正に使用、もしくは第三者（配偶者、父母、兄弟姉妹等の親族を含む。以下同じ）に使用させた場合
(５) 不正の目的をもって本サービスを利用、もしくは第三者に利用させた場合、又は第三者による不正の防止を行うために必要な場合
(６) その他、当社がポイント利用者として不適当と判断した場合
２.前項に基づき当社が利用資格を停止、取り消したことにより、ポイント利用者に生じた不利益、損害について、当社の責に帰すべき事由による場合を除き、当社は一切の責任を負いません。また、当社、ポイント交換パートナー企業又は第三者が被った損失、損害に対する補償及び費用の負担は当該ポイント利用者が行うものとします。
３.ポイント利用者の本サービス利用に関して疑義が生じた場合、当社の判断により利用資格の一時停止、本サービスの利用の制限をさせていただくことがあります。

第７条（利用資格の停止・取り消しに伴う本ポイントの消滅）
ポイント利用者が第６条にもとづいて利用資格を停止ないし取り消された場合、第１７条で定める本ポイントの有効期限にかかわらず、既に蓄積されている本ポイントは、全て自動的に消滅するものとし、本規定もしくは本サービスにおける本ポイントに関する権利・義務の全ても自動的に消滅するものとします。ただし、利用システムの終了・中止に伴う資格喪失の場合には、次条の定めによります。

第８条（本サービスの終了、中止に伴う本ポイントの扱い）
当社が、第１０条の規定に従って、本サービスを終了もしくは中止する場合、第１７条で定める本ポイントの有効期限にかかわらず、第１０条所定の一定予告期間の経過時点で残存本ポイントが消滅するものとします。なお、予告期間中は、新規の本ポイントの取得はできません。

第９条（利用の制限）
ポイント利用者は、本規約に定めるほか、次のいずれかに該当する場合には、本サービスをご利用いただくことができません。
(１) 違法又は不正な方法により作成、取得若しくは利用された本ポイントを利用する場合
(２) 第三者のCLUB Panasonic会員ID・パスワードを用いて本サービスを利用した場合
(３) 通信回線、通信機器及びコンピューターシステム機器の障害による情報伝達の遅延、不能、誤作動等があった場合
(４) ポイント利用者が第６条に該当し利用資格の停止、取り消し等がなされた場合

第１０条（サービスの終了・中止・変更等）
当社は、一定の予告期間をおいて周知の方法を取った上で本サービスを終了もしくは中止し、又は内容を変更することができるものとし、ポイント利用者は予めその旨承認するものとします。ポイント交換パートナー企業は、当社との加盟契約の新規締結や終了によって、ポイント利用者に事前の通知なく増減します。

第１１条（ポイント利用者としての地位の譲渡等の制限）
ポイント利用者は、理由の如何を問わず、ポイントサービスにおける権利・義務を他人に貸与譲渡、担保提供、保有する本ポイントをポイント利用者間で共有、合算、贈与、賃貸、質入れ及び譲渡することはできません。

第１２条（ポイント交換）
１．ポイント利用者は、当社所定のレートに従って、当社所定の単位で本ポイントをCLUB Panasonicコインに交換することができます。本ポイントの交換レート及び交換単位は、当社都合により変更されることがあります。
２．当社都合により、CLUB Panasonicコインへの交換ができない場合がありますのでご了承ください。

第１３条（ポイントの交換単位）
１．本ポイントは1ポイントより有効であり、CLUB Panasonicコインに交換できます。ただし、ポイント利用者は、当社の定めにより、一定数以上の本ポイントでなければCLUB Panasonicコインに交換できないことがあることを了承するものとします。
２．本ポイントとCLUB Panasonicコインとの間の交換レートは、本アプリ上で常時告知されており、ポイント利用者は自由に閲覧、参照することができます。

第１４条（本ポイントの取得）
１．ポイント利用者は、本アプリ上で提供されるサービスの利用、条件の達成等にともない、当社が発行する本ポイントを取得することができます。
２．本ポイントの取得についての条件、規制等は、当社による事前の取り決めによって決定されるものとし、それらの条件、規制等は本アプリ、又はその他の媒体において告知されており、ポイント利用者において自由に閲覧、参照することができます。
３.ポイント利用者が当該本ポイントを取得した後に、前項の条件、規制等に反することが明らかになった場合、当社は、その旨を通知のうえ、当該本ポイントの取得を取り消すことができます。

第１５条（本ポイントの利用）
ポイント利用者は、本ポイントを、所定の方法に従って、当社又はポイント交換パートナー企業の提供する商品・サービスの購入代金の充当等に利用することができます。ただし、ポイント利用者は、本ポイントを現金と交換することはできません。

第１６条（本ポイント利用にかかる手数料等）
ポイント利用者は、ポイント交換や本ポイントの利用に際して、当社が定める費用・手数料等を負担するものとします。また、当該費用・手数料等に課される消費税その他公課公租についても自らこれを負担するものとし、当社はこれらを一切負担しないものとします。

第１７条（本ポイントの有効期限）
１．本ポイントの有効期限はポイント利用者が最後に本ポイントを交換、取得もしくは利用した日より12ヶ月とします。
２．有効期限が到来する前に、当社はポイント利用者に対して有効期限到来を本アプリにて通知します。
３．ポイント利用者が有効期限までに本ポイントの交換、取得、利用を行えば、保有本ポイントの有効期限はそれぞれの交換、取得、利用時から12ヶ月延長されます。
４．この通知にもかかわらず、有効期限までにポイント利用者による本ポイントの交換、取得もしくは利用が無かった場合には、既に蓄積されている本ポイントは、全て自動的に消滅します。

第１８条（本ポイント保有残高の制限）
１．ポイント利用者が口座に保有するポイント数が999,999ポイントを超えた場合、システムの都合により、ポイント数を画面上に正しく表示できないことがあります。
２．当社の都合により、ポイント利用者が口座に保有可能なポイント数に上限が設けられることがあります。

第１９条（本ポイントに関する疑義）
本サービスの利用内容について、ポイント利用者と当社との間で疑義が生じた場合には、当社の保有する当該ポイント利用者の本サービス利用データに基づき、当社において対応を決定させていただきます。

第２０条（本ポイントの取り消し）
以下のいずれかの事項に該当する場合、当社はポイント利用者の保有する本ポイントの一部又は全部を取り消すことができます。また、当社は取り消した本ポイントに対して一切の保証を行いません。
（１）ポイント利用者が不正な手段によって本ポイントを取得した場合
（２）ポイント利用者が本規約又は別途定めた各種規定に違反した場合
（３）当社の過失等により、必要数を超えて本ポイントが付与された場合
（４）その他、当社がポイント利用者に付与された本ポイントを取り消すことが適切であると判断した場合

第２１条（免責事項）
１．ポイント利用者が、ポイントを利用して商品を取得した場合に生じるポイント交換パートナー企業との間の商品の瑕疵、品違い、数量過誤等の全てのトラブルは、当該利用者と当該ポイント交換パートナー企業の当事者間で直接解決するものとし、当社の責に帰すべき事由による場合を除き、当社は一切責任を負いません。
２．当社は、ポイント交換パートナー企業が提供する商品・サービスや情報及び取引等について、一切保証を行いません。また、その内容、品質等についてのトラブルは、ポイント利用者と当該ポイント交換パートナー企業の当事者間で直接解決するものとし、当社の責に帰すべき事由による場合を除き、当社は一切責任を負いません。
３．本サービスを通じたポイント利用者と広告主等の第三者との取引（無料登録、資料請求等を含む）において発生する全てのトラブルについて、当該利用者と当該広告主の当事者間で直接解決するものとし、当社の責に帰すべき事由による場合を除き、当社は一切責任を負いません。
４．当社は、ポイント交換パートナー企業がポイント利用者の本ポイントの取得についてその理由の如何を問わず結果として承認しなかった場合、当社の責に帰すべき事由による場合を除き、当該本ポイントの付与・補填、不承認理由の調査等を含み一切責任を負いません。
５．本サービスが他サイトへのリンクを行っている場合であっても、ポイント利用者が当該サイトを利用又は使用したことに起因する結果（損害、費用負担等）について、当社の責に帰すべき事由による場合を除き、当社は一切責任を負いません。
６．理由の如何を問わず、本アプリにCLUB Panasonic会員としてログインしたうえで本サービスが利用された場合、CLUB Panasonic会員ID・パスワード等について盗用その他の事故等があっても、その結果生ずる本ポイント及び本ポイントに付随する価値の消失、その他一切の損害については、当社の責に帰すべき事由による場合を除き、全てポイント利用者の責任となります。
７．当社は、前各項に定めるほか、以下のいずれの事項によってポイント利用者に生じる損害については、当社の責に帰すべき事由による場合を除き、その責を一切負わないものとします。
（１）通信回線、通信機器及びコンピューターシステム機器の障害による情報伝達の遅延、不能、誤作動等
（２）本サービスの利用につき、ポイント利用者による本サービスの内容又はその利用方法についての誤解もしくは理解不足によって発生した損害
（３）当社推奨環境以外で利用された際に発生した損害
（４）ポイント利用者が利用情報の変更を怠ったことに起因して発生した損害
（５）本規約に違反する行為を行ったことにより発生した損害

パナソニック株式会社
発効日2025年4月1日



■プライバシーポリシー

パナソニックグループ（パナソニック ホールディングス株式会社、その連結子会社および持分法適用関連会社をいい、以下同様とします）は、Panasonicブランドの家電製品（以下、「家電製品」といいます）や日々の生活のお役立ち情報に関する種々のコンテンツをWebサイトや専用アプリを通じてCLUB Panasonic会員サービス（以下、「CLUB Panasonic」といいます）としてご提供するとともに、インターネットに接続できる機能を持つ各種家電製品に対応する種々のアプリ（以下、「家電アプリ」といいます）をご提供し、CLUB Panasonicご登録時やご利用の際にいただいた情報（以下、「CLUB Panasonic情報」といいます）や家電製品と連携したサービスをご提供しています。スムースエピアプリ iOS版（「本アプリ」）は、パナソニック株式会社（以下、「当社」といいます）が提供する家電アプリの一つです。お客様には当社の美容家電と連携したサービス（「本サービス」）をご利用いただけます。

本アプリのご利用を開始いただきますと、当社は本アプリおよび対象美容家電からご利用に関する情報など以下１で定める情報（「プライバシー情報」）を取得し、本サービスの提供をはじめ以下２で定める目的（「利用目的」）で利用します。

当社は、お客様および本アプリや対象美容家電などから、様々な情報をお預かりしており、これらの情報はお客様のプライバシーに関する重要なものであると認識しております。そこで、本サービスをご利用される際に、お客様からお預かりするプライバシー情報の取扱いに関する基本方針を、プライバシーポリシーとしてここに定め（「本ポリシー」）､同意をいただいています。本アプリや対象美容家電をお使いの他の方にも、本ポリシーの内容をご理解いただき、同意をいただくようにお願い致します。なお、本ポリシーは、本サービスをお客様にご利用いただく際に当社が取得し利用するプライバシー情報の取扱いについて適用されます。

１．取得および利用するプライバシー情報
当社は、本サービスにおいて、以下のプライバシー情報を取得し、利用いたします。
（１）本アプリから取得する情報
・本アプリに登録された品番などの対象美容家電に関する情報
・お客様が本アプリに登録される性別・生年月・脱毛サロン/クリニックの利用歴など、お客様に関する情報
・IPアドレスやMACアドレスなどインターネット接続に必要な情報
・本アプリを利用してお手入れを行った内容など、本アプリのご利用に関する情報
・鼻下から唇上部ラインまでの領域（横の範囲は左右の口角の間の領域）の写真と分析データ
・お客様がお使いのスマートフォンに割り当てられている識別子

（２）CLUB Panasonic情報
・ご氏名、ご住所、電話番号、メールアドレス､性別等のCLUB Panasonicに登録されたお客様に関する情報
・PanasonicのWebサイトの閲覧履歴、CLUB Panasonicアプリの使用時間など、CLUB Panasonicのご利用に関する情報

（３）本アプリ以外の家電アプリや、家電アプリに登録された家電製品のご利用に関する情報
・エオリアアプリなど、本アプリと連携しているCLUB Panasonic IDと同一のIDでログインされている家電アプリや、それらのアプリに登録された家電製品のご利用に関する情報
・本アプリが利用するIPアドレスなどと同一の情報を使う家電アプリや家電製品のご利用に関する情報

（４）第三者から取得する情報
・第三者のサービスをご利用の際にお客様が同意された範囲内で当社に提供される、お客様に関する情報（当該サービスのご利用に関する情報など）

２．取得した情報の「利用目的」
当社は、お客様からお預かりしたプライバシー情報を、以下の利用目的で利用します。なお、当社が利用するプライバシー情報には、本ポリシーに同意いただいた後に取得した情報のほか、それよりも前に当社の別途の利用規約などの規定に同意いただいた上で取得した情報も含みます。
①本アプリや本サービスを提供するため
②本サービス、本アプリ､および対象美容家電に関して、お客様からのお問合せ､修理、アフターサービスに対応するため
③CLUB Panasonic会員登録が利用条件となっているサービスを提供するため
④本アプリ、本サービス、対象美容家電をはじめ、当社の商品、アプリ、サービスの改善、改良や品質向上､および新規開発のため 
⑤本サービス上、当社の他のサービス上、およびアプリ上での広告やコンテンツの掲示・配信など、以下３に定義するパナソニックグループが取り扱う商品、サービスの販売促進やマーケティング活動のため
⑥③、④、⑤を効果的に実施する目的で、本サービスをお使いのお客様の趣味・嗜好などの属性を分析し、推定するため
⑦お客様から本ポリシーや別途の規定で同意いただいた範囲内で、または法令上許容される範囲内で、プライバシー情報を第三者に提供するため（第三者に提供するためにプライバシー情報を統計や匿名加工データに加工する目的を含む）
⑧その他、お客様から本ポリシーや別途の規定で同意をいただいた目的で利用するため

３．プライバシー情報の共同利用
（１）パナソニックグループのうち、日本法に基づいて設立された会社（以下、「共同利用会社」といいます）は、プライバシー情報のうち、CLUB Panasonic情報を、CLUB Panasonic会員利用規約の一部である『CLUB Panasonic　プライバシーポリシー』（以下、「CLUB Panasonicプライバシーポリシー」といいます）の定めにしたがって、共同して利用します。

（２）共同利用会社は、プライバシー情報のうち、CLUB Panasonic情報以外の情報（以下、「利用データ」といいます）を、次のとおり、共同して利用します。
①共同して利用されるIoT家電データの項目
本ポリシーの１（１）、（３）、（４）に列挙するもの
②共同して利用する者の範囲
パナソニックグループ
③共同して利用する者の利用目的
本ポリシーの２に記載の利用目的
④共同して利用するプライバシー情報の管理責任者
本ポリシー５に掲げる者
⑤取得方法
インターネット（本アプリ、家電アプリ、家電製品）

４．プライバシー情報を第三者に提供する場合
（１）当社は、以下のいずれかに該当する場合に限って、第三者にプライバシー情報を提供できるものとします。
①利用目的に即してプライバシー情報を利用するのに必要な範囲で、業務委託先に提供する場合
②お客様ご本人が識別されない状態に加工した統計情報・匿名加工等のデータを提供する場合
③合併等による事業の承継に伴ってプライバシー情報が提供される場合
④本ポリシーの３に基づいて共同利用をする場合
⑤法令に基づく場合
⑥お客様、第三者、ならびに当社の役員および従業員の生命、健康、財産もしくは権利等、または当社の財産もしくは権利等を保護するために必要であって、かつ、お客様の同意を得ることが困難である場合
⑦国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、お客様の同意を得ることにより、当該事務の遂行に支障を及ぼすおそれがあるとき
⑧法令の規定に基づき、裁判所、警察、検察その他の国家機関またはこれに類する機関より、開示を求められた場合
⑨前述のもののほか、CLUB Panasonicや本アプリに関する利用規約への同意など、本ポリシーへの同意とは別途、プライバシー情報を第三者に提供することについて、お客様に同意いただいている場合

（２）前述の（１）に定める場合であれば、当社は、第三者が外国法人であるときや、第三者のサーバーが外国にあるときなど、プライバシー情報が外国に移転されるときであっても、第三者に提供できるものとします。

（３）当社が前述の（１）②に基づいてプライバシー情報を第三者に提供した場合に、当該第三者は、当該第三者の商品やサービスの提供、およびこれらの開発等の目的で利用し、さらに第三者に開示することや、任意の国にプライバシー情報を移転させることがあります。また、プライバシー情報の開示を受けた第三者は、別途お客様から同意を得た範囲内で、プライバシー情報をお客様の個人情報と関連付けた上で、サービスを提供することがあります。

（４）当社は、利用目的の③に必要な範囲で、Google AnalyticsおよびGoogle Analytics for Firebase等、第三者の情報収集モジュールを利用します。Google AnalyticsおよびGoogle Analytics for Firebaseは、お客様ご本人を識別できないプライバシー情報を自動的に収集し、Google LLC等の当該モジュールの提供者に送信します。当社は、前述の（１）②に基づき、当該プライバシー情報を当該提供者に送信します。送信されたプライバシー情報は、当該モジュールの提供者が定めるプライバシーポリシーその他の規定に基づいて管理されます。
なお、Google AnalyticsおよびGoogle Analytics for Firebaseを当社が利用する際に、お客様のプライバシー情報がどのように収集され、処理されるかについては、https://www.google.com/policies/privacy/partners/のサイトをご確認ください。

５．プライバシー情報の管理責任者
プライバシー情報のうち、利用データの管理責任者は以下の通りです。
なお、CLUB Panasonic情報の管理責任者は、CLUB Panasonicプライバシーポリシーに記載の通りです。

【事業者名】
 パナソニック株式会社　
【住所】
 東京都品川区西五反田３丁目５－２０　パナソニック目黒ビル
【代表者】
 豊嶋 明
【管理責任者】
 本サービスにおける個人情報保護管理者

６．プライバシー情報の取得・利用・第三者への提供等の中止
（１）お客様が、プライバシー情報の利用目的の通知、プライバシー情報の開示、内容の訂正、追加もしくは削除、利用の中止、または第三者への提供の中止を求める場合には、下記に定めるお問い合わせ窓口指定の方法でお申し出いただくことができ、当社はこのお申し出に応じるものとします。

                      記
CLUB Panasonic事務局：
https://panasonic.jp/membership/inquiry/

（２）お客様は、本アプリをご利用のスマートフォンからアンインストールすることで、本アプリからのプライバシー情報の取得を中止させることができます。

（３）お客様が第三者のサービスのご利用にあたって、本アプリと当該サービスを連携してプライバシー情報を当該第三者に提供することに同意した場合について、お客様は本アプリから第三者のサービスとの連携を中止することで、プライバシー情報の提供を中止することができます。

（４）お客様が本項に基づいてプライバシー情報の取得等を中止させた場合、本サービスの全部または一部をご利用いただけなくなる可能性があります。また、本項に基づいてプライバシー情報の利用の中止をお申し出いただいたとしても、その時点でお客様から同意をいただき取得した利用については削除されず、利用目的の範囲内で利用されます。

７．安全管理措置
当社では、お客様からお預かりしたプライバシー情報を適切に管理するために様々な施策を講じております。具体的な施策の内容については、CLUB Panasonicの『お客様からお預かりしたパーソナルデータについて』（https://panasonic.jp/membership/data-privacy）をご参照ください。

８．本ポリシーの文面の変更について
当社では、法令などの変更に対応するため、または当社によるプライバシー情報の利用や取扱いに変更がある場合など、当社が必要と判断する場合に、本ポリシーの全部または一部を変更することがあります。この場合、変更後の本ポリシーに同意をいただきますようお願い致します。変更した本ポリシーに同意いただけない場合には、本サービスの全部または一部をご利用いただけなくなる場合がありますので、予めご了承ください。

パナソニック株式会社
発効日2026年4月1日 

</pre
    >
  </div>
</template>

<style>
.privacy-partners-link {
  /* リンクを無効にする */
  pointer-events: none;
}
pre {
  white-space: pre-wrap;
  font-family: "ヒラギノ角ゴ ProN W3", NotoSansJP, NotoSansCJKjp, sans-serif;
  text-align: left;
}
</style>
